import useStyles from "../styles";
import logo from "../../../assets/images/logo.svg";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Grid
} from "@mui/material";
import styles from "../report.module.css";
import profileimg from "../../../assets/images/profile-no-bg.png";

const FirstReport = ({ reportData, obtainablescore, appLogo, reportRef, profile }) => {
  const classes = useStyles();

  // Add this function to generate unique keys
  const generateKey = (prefix, index, id) => {
    return id ? `${prefix}_${id}` : `${prefix}_${index}`;
  };

  return (
    <div ref={reportRef} className="white_bg container-border page-content">
      <div className={classes.reportmain}>
        <div className={classes.reportheader}>
          <Grid container spacing={2}>
            <Grid item lg={3} md={3} sm={3} xs={12}>
              <div className={classes.imageWrapper}>
                <img
                  src={appLogo && appLogo !== "null" ? appLogo : logo}
                  alt="App Logo"
                  className={appLogo && appLogo !== "null" ? classes.secondlogoContent : classes.logoContent}
                />
              </div>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <div className={classes.reportheadertext}>
                <h1>{reportData?.school_name || profile?.school_name}</h1>
                <p>{reportData?.school_address || profile?.address}</p>
                <p>{reportData?.phone_number || profile?.phone_number}, {reportData?.email || profile?.email}</p>
              </div>
            </Grid>
            <Grid item lg={3} md={3} sm={3} xs={12}>
              <div>
                <img
                  src={reportData?.display_pic?.file_url || profileimg}
                  alt="Profile"
                  className={classes.profile}
                />
              </div>
            </Grid>
          </Grid>
        </div>

        <div className={classes.termdata}>
          <h1>2024/2025 FIRST TERM STUDENT REPORT</h1>
        </div>

        <Grid container spacing={2}>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>STUDENT NAME</h6>
              <p>{reportData?.last_name || "--/--"} {reportData?.first_name || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>SEX</h6>
              <p>{reportData?.gender || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>CLASS</h6>
              <p>{reportData?.class?.name || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>SESSION</h6>
              <p>{reportData?.session?.session || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>ADMISSION DATE</h6>
              <p>{reportData?.admission_date?.substring(0, 10) || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>CLASS POPULATION</h6>
              <p>{reportData?.class_population || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>ADMISSION NO.</h6>
              <p>{reportData?.admission_no || "--/--"}</p>
            </div>
          </Grid>
        </Grid>

        <div className={classes.termdata}>
          <h1>SUBJECTS</h1>
        </div>
      </div>

      {/* Subject Results */}
      <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 2, mt: 4, overflowY: "auto" }}>
        <Table sx={{ minWidth: 900 }} aria-label="student performance table">
          <TableHead sx={{ backgroundColor: "#f9fafb" }}>
            <TableRow>
              <TableCell sx={{
                position: "sticky",
                left: 0,
                backgroundColor: "#f9fafb",
                zIndex: 2,
                fontWeight: "500"
              }}
              >
                <strong>Subject</strong>
              </TableCell>
              {obtainablescore?.[0]?.ca?.map((ca, index) => (
                <TableCell
                  key={generateKey("ca_header", index, ca?.ca_type)}
                  align="center"
                >
                  {ca?.ca_type}
                  <br /><Typography variant="caption">({ca?.score})</Typography>
                </TableCell>
              ))}
              <TableCell align="center">Exam<br /><Typography variant="caption">(60)</Typography></TableCell>
              <TableCell align="center">Total<br /><Typography variant="caption">(100)</Typography></TableCell>
              <TableCell align="center">Class<br />Highest</TableCell>
              <TableCell align="center">Class<br />Lowest</TableCell>
              <TableCell align="center">Class<br />Average</TableCell>
              <TableCell align="center">Grade</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reportData?.subjects?.map((row, idx) => (
              <TableRow key={generateKey("subject", idx, row?.id)}>
                <TableCell sx={{
                  position: "sticky",
                  left: 0,
                  backgroundColor: "#fff",
                  zIndex: 1
                }}
                >
                  {row.name}
                </TableCell>
                {obtainablescore?.[0]?.ca?.map((ca, caIndex) => (
                  <TableCell
                    key={generateKey("ca_score", caIndex, ca?.ca_type)}
                    align="center"
                  >
                    {row?.scores?.CA_scores?.[ca?.ca_type] ?? "-"}
                  </TableCell>
                ))}
                <TableCell align="center">{row?.scores?.exam_score || "-"}</TableCell>
                <TableCell align="center">{row?.scores?.total || "-"}</TableCell>
                <TableCell align="center">{row?.scores?.class_highest_score || "-"}</TableCell>
                <TableCell align="center">{row?.scores?.class_lowest_score || "-"}</TableCell>
                <TableCell align="center">
                  {row?.scores?.class_average_score ? row.scores.class_average_score.toFixed(2) : "-"}
                </TableCell>
                <TableCell align="center">{row?.scores?.grade || "-"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Attendance */}
      <div className={classes.termdata}>
        <h1>ATTENDANCE</h1>
      </div>
      <TableContainer component={Paper} sx={{ borderRadius: 2, mt: 4, boxShadow: 1 }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#f9fafb" }}>
            <TableRow>
              <TableCell align="center"><strong>TOTAL NO. OF DAYS</strong></TableCell>
              <TableCell align="center"><strong>NO. OF DAYS PRESENT</strong></TableCell>
              <TableCell align="center"><strong>NO. OF DAYS ABSENT</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow key="attendance_row">
              <TableCell align="center">{reportData?.total_days || "--"}</TableCell>
              <TableCell align="center">{reportData?.days_present || "--"}</TableCell>
              <TableCell align="center">{reportData?.days_absent || "--"}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {/* Extracurricular and Comments */}
      {(reportData?.extras?.length > 0) && (
        <Grid container spacing={3} sx={{ mt: 1 }}>
          {reportData.extras
            .filter(item => item.section_type === "grade" || item.section_type === "score")
            .map((section, index) => (
              <Grid item xs={12} md={6} key={generateKey("extra", index, section.section_name)}>
                <Paper elevation={2} sx={{ borderRadius: 2, p: "8px 14px" }}>
                  <Box sx={{ position: "relative" }}>
                    <div className={classes.termdata}>
                      <h1>{section.section_name.toUpperCase()}</h1>
                    </div>
                  </Box>
                  <Table sx={{ mt: 2 }}>
                    <TableHead sx={{ backgroundColor: "#f9fafb" }}>
                      <TableRow>
                        <TableCell>ACTIVITY</TableCell>
                        <TableCell align="right">
                          {section.section_type === "grade" ? "GRADE" : "SCORE"}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Object.entries(section.section_value).map(([activity, value], activityIndex) => (
                        <TableRow key={generateKey("activity", activityIndex, activity)}>
                          <TableCell>
                            {activity.split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}
                          </TableCell>
                          <TableCell align="right">{value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Paper>
              </Grid>
            ))}

          {/* Teacher's Comment */}
          {reportData?.extras
            .filter(item => item.section_type === "text")
            .map((section, index) => (
              <Grid item lg={6} md={6} sm={6} xs={12} key={generateKey("comment", index, section.section_name)}>
                <Paper elevation={2} sx={{ borderRadius: 2, p: "8px 14px" }}>
                  <Box sx={{ position: "relative" }}>
                    <div className={classes.termdata}>
                      <h1>TEACHER'S COMMENT</h1>
                    </div>
                  </Box>
                  <Box
                    sx={{
                      mt: 2,
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: "#f9fafb",
                      fontSize: "0.95rem",
                      textAlign: "left",
                      color: "#333"
                    }}
                  >
                    {section?.section_value || "No comment available."}
                  </Box>
                </Paper>
              </Grid>
            ))}
        </Grid>
      )}

      {/* Signatures Section */}
      <Grid container spacing={3} className={styles.signdiv}>
        <Grid item lg={7} md={7} sm={7} xs={12} className={styles.sign}>
          <div>
            <p>Class Teacher’s Signature</p>
            {reportData?.class_teacher_signature?.file_url && (
              <img src={reportData.class_teacher_signature.file_url} alt="Teacher signature" />
            )}
          </div>
          <div>
            <p>Admin’s Signature</p>
            {profile?.branding?.signature?.file_url && (
              <img
                src={profile.branding.signature.file_url}
                alt="Admin’s Signature"
              />
            )}
          </div>
        </Grid>
        <Grid item lg={4} md={4} sm={4} xs={12} className={styles.seal}>
          <img src={profile?.branding?.school_stamp?.file_url} />
        </Grid>
      </Grid>

    </div>
  );
};

export default FirstReport;
